import { Controller } from 'stimulus';

export default class extends Controller {
  editSection(event: Event) {
    event.preventDefault();
    const sectionRow = this.sectionRowFromEvent(event);
    if (!sectionRow) return;

    sectionRow.querySelectorAll('.edit-field').forEach((el: HTMLElement) => {
      el.style.display = 'block';
    });
    sectionRow.querySelectorAll('.display-value').forEach((el: HTMLElement) => {
      el.style.display = 'none';
    });

    const editBtn = sectionRow.querySelector('.edit-section') as HTMLElement | null;
    const saveBtn = sectionRow.querySelector('.save-section') as HTMLElement | null;
    const cancelBtn = sectionRow.querySelector('.cancel-section') as HTMLElement | null;

    if (editBtn) editBtn.style.display = 'none';
    if (saveBtn) saveBtn.style.display = 'inline-block';
    if (cancelBtn) cancelBtn.style.display = 'flex';
  }

  cancelEdit(event: Event) {
    event.preventDefault();
    const sectionRow = this.sectionRowFromEvent(event);
    if (!sectionRow) return;

    sectionRow.querySelectorAll('.edit-field').forEach((el: HTMLElement) => {
      el.style.display = 'none';
    });
    sectionRow.querySelectorAll('.display-value').forEach((el: HTMLElement) => {
      el.style.display = 'inline';
    });

    const editBtn = sectionRow.querySelector('.edit-section') as HTMLElement | null;
    const saveBtn = sectionRow.querySelector('.save-section') as HTMLElement | null;
    const cancelBtn = sectionRow.querySelector('.cancel-section') as HTMLElement | null;

    if (saveBtn) saveBtn.style.display = 'none';
    if (cancelBtn) cancelBtn.style.display = 'none';
    if (editBtn) editBtn.style.display = 'inline-block';
  }

  saveSection(event: Event) {
    event.preventDefault();
    const sectionRow = this.sectionRowFromEvent(event);
    if (!sectionRow) return;

    const itemId = sectionRow.dataset.itemId;
    const termId = sectionRow.dataset.termId;
    if (!itemId || !termId) return;

    const formData = new FormData();
    sectionRow.querySelectorAll('.edit-field input').forEach((input: HTMLInputElement) => {
      formData.append(input.name, input.value);
    });

    fetch(`/items/${itemId}/style_warranty_fields/update_manufacturer_warranty_term/${termId}`, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': this.getCsrfToken(),
        'Accept': 'application/json'
      },
      body: formData
    })
      .then((resp) => {
        if (resp.ok) {
          window.location.reload();
        } else {
          alert('Error saving warranty dates');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Error saving warranty dates');
      });
  }

  private sectionRowFromEvent(event: Event): HTMLElement | null {
    const el = event.currentTarget as HTMLElement;
    return (el.closest("[data-controller='items--style-warranty-field']") as HTMLElement) || null;
  }

  private getCsrfToken(): string {
    const token = document.querySelector("meta[name='csrf-token']") as HTMLMetaElement;
    return token ? token.getAttribute('content') || '' : '';
  }
}

